import { handleActions } from 'redux-actions';
import { setTrialBalanceSnapshotViewLoaded } from 'store/actions/trial-balance/trial-balance-snapshot-view-action';

const DEFAULT = false;

export default handleActions(
  {
    [setTrialBalanceSnapshotViewLoaded]: (_, { payload }) => {
      return payload;
    },
  },
  DEFAULT,
);

export const snapshotReadOnlyReducer = handleActions(
  {
    [setTrialBalanceSnapshotViewLoaded]: () => false,
  },
  false,
);
